import { render, staticRenderFns } from "./common.md?vue&type=template&id=f1673e4c&"
import script from "./common.md?vue&type=script&lang=js&"
export * from "./common.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1673e4c')) {
      api.createRecord('f1673e4c', component.options)
    } else {
      api.reload('f1673e4c', component.options)
    }
    module.hot.accept("./common.md?vue&type=template&id=f1673e4c&", function () {
      api.rerender('f1673e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/scatter/common.md"
export default component.exports